/** @format */

/**
 * Splits a string with line breaks into an array of trimmed lines
 */
export const splitLines = (lines: string) =>
    lines
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter((line) => line);
